<div
	class="andromeda-menu-trigger"
	[ngClass]="{ 'disable-trigger': disabled }"
	cdkOverlayOrigin
	#trigger="cdkOverlayOrigin"
	(click)="onClickOnMenuTrigger($event)"
>
	<ng-content #menuTrigger select="[menuTrigger]"></ng-content>
</div>

<ng-template
	cdkConnectedOverlay
	[cdkConnectedOverlayFlexibleDimensions]="true"
	[cdkConnectedOverlayOrigin]="trigger"
	[cdkConnectedOverlayOpen]="isOpen"
	[cdkConnectedOverlayHasBackdrop]="true"
	[cdkConnectedOverlayPanelClass]="'andromeda-menu-body'"
	[cdkConnectedOverlayBackdropClass]="'andromeda-backdrop'"
	(overlayOutsideClick)="clickOnBackdrop($event)"
	(backdropClick)="clickOnBackdrop($event)"
>
	<div (click)="optionHasBeenClicked($event)">
		<ng-content select="[menuContent]"></ng-content>
	</div>
</ng-template>
